<template>
  <el-button type="text" class="!text-lg" :loading="loading" size="default" @click="$emit('click')">
    <slot v-if="!loading">
      <i :class="[icon, cls]" />
    </slot>
  </el-button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'df'
    },
    icon: {
      type: String,
      default: 'df'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    cls() {
      return {
        'df': '',
        'del': 'text-purple-500 hover:text-red-500'
      }[this.type] || ''
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
